import { WorkflowPerson } from '../types';

const computeIMC = (person: WorkflowPerson) => {
  if (person.height === 0) {
    return Infinity;
  }
  return person.weight / Math.pow(person.height / 100, 2);
};

export { computeIMC };
